"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    d: "M12,2 C17.5227273,2 22,6.47704545 22,12 C22,17.5229545 17.5227273,22 12,22 C6.47727273,22 2,17.5229545 2,12 C2,6.47704545 6.47727273,2 12,2 Z M16.6645904,7.42374545 L10.4738939,13.7028333 L7.35821185,10.4377847 L5.91113145,11.8183492 L9.76006017,15.8520392 C10.1231096,16.2099393 10.6905242,16.2336168 11.0806269,15.9257979 L11.1742377,15.8419385 L18.0888685,8.82782225 L16.6645904,7.42374545 Z"
  });
}.bind(void 0));

exports.default = _default;